module.exports = __webpack_public_path__ + "e5c35a3fcd246f79135fc4300f1874b1.obj";